// extracted by mini-css-extract-plugin
module.exports = {"root":"LjX4o9rfrKo9Y0LF6rm5"};